import { v4 as uuidv4 } from 'uuid';

import { convertKnmDataViolationsToFormValues } from 'KnmErknmPackage/MainModule/common/convertKnmDataViolationsToFormValues';

import { IKnmErknmFormViolatedRequirementsNpa } from '../interfaces/IKnmErknmFormViolatedRequirementsNpa';
import { IKnmViolatedRequirementsNpa248 } from '../../../APIPackage/KnmModule/interfaces/IKnmViolatedRequirementsNpa248';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';
import { createMandatoryCategorySelectOption } from '../../../CorePackage/CatalogsModule/common/createMandatoryCategorySelectOption';

export function convertKnmDataViolatedRequirementsToFormValues(
  violatedRequirements: IKnmViolatedRequirementsNpa248[],
): IKnmErknmFormViolatedRequirementsNpa[] {
  return violatedRequirements.map(requirement => ({
    guid: requirement.guid || uuidv4(),
    npa: {
      id: requirement.npaId,
      number: requirement.number || undefined,
      title: requirement.title || undefined,
      acceptanceDate: formatDate({
        date: requirement.acceptanceDate ?? '',
        dateFormat: DATE_FORMAT_LONG_FNS,
        parseFormat: SYSTEM_DATE_FORMAT_FNS,
      }),
    },
    structuralUnit: {
      id: requirement.structuralUnit.id,
      title: requirement.structuralUnit.title || undefined,
    },
    violatedMandatory:
      requirement.structuralUnit.mandatoryRequirementsViolations?.map(mandatoryItem => {
        return {
          mandatory: {
            id: mandatoryItem.id,
            title: mandatoryItem.title || '',
          },
          category: mandatoryItem.category ? createMandatoryCategorySelectOption(mandatoryItem.category) : undefined,
          violationIds: mandatoryItem.violationIds,
          violations: mandatoryItem.violations?.length
            ? convertKnmDataViolationsToFormValues(mandatoryItem.violations)
            : null,
        };
      }) || [],
  }));
}
